import React, { useState } from 'react';
import { BookOutlined, TranslationOutlined } from '@ant-design/icons';
import TraduccionSCSP from './TraduccionSCSP';
import TraduccionSPSC from './TraduccionSPSC';
import CompromisoDetalle6 from './CompromisoDetalle6';

const BRAND      = '#0072CE';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BRAND_DARK = '#005ba3';

const ALL_TABS = [
  { key: 'traduccion',  label: 'Traducción',  icon: <TranslationOutlined style={{ fontSize: 18 }} /> },
  { key: 'compromiso6', label: 'Compromiso 6', icon: <BookOutlined       style={{ fontSize: 18 }} /> },
];

interface TraductorContentProps {
  item: any;
  documents?: any[];
  loadingDocuments?: boolean;
  onRefresh?: () => void;
  onCompleted?: () => void;
}

const TraductorContent: React.FC<TraductorContentProps> = ({ item, documents = [], loadingDocuments = false, onRefresh, onCompleted }) => {
  const origin      = new URLSearchParams(window.location.search).get('origin');
  const isFromComp6 = origin === 'comp_6';
  const isSpSc      = item?.translationDirection === 'SP_TO_SC';
  const TABS = (isFromComp6 || isSpSc) ? ALL_TABS.filter(t => t.key !== 'compromiso6') : ALL_TABS;
  const [activeTab, setActiveTab]       = useState(0);
  const [, setCompromisoSaved] = useState(false);

  const compromisoTabIndex = TABS.findIndex(t => t.key === 'compromiso6');

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: 500 }}>

      {/* ── Vertical tab strip ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, zIndex: 1, flexShrink: 0 }}>
        {TABS.map((tab, i) => {
          const active = activeTab === i;
          return (
            <div
              key={tab.key}
              onClick={() => setActiveTab(i)}
              style={{
                width: 52,
                height: 200,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 12,
                borderRadius: '8px 0 0 8px',
                background: active ? BRAND : '#ebebeb',
                color: active ? '#fff' : '#666',
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'background .2s, color .2s',
                boxShadow: active ? `2px 0 0 0 ${BRAND}` : 'none',
              }}
              onMouseEnter={e => { if (!active) (e.currentTarget as HTMLDivElement).style.background = '#d9d9d9'; }}
              onMouseLeave={e => { if (!active) (e.currentTarget as HTMLDivElement).style.background = '#ebebeb'; }}
            >
              <span style={{
                writingMode: 'vertical-rl',
                transform: 'rotate(180deg)',
                fontWeight: 600,
                fontSize: 12,
                letterSpacing: 1,
                whiteSpace: 'nowrap',
              }}>
                {tab.label}
              </span>
              {tab.icon}
            </div>
          );
        })}
      </div>

      {/* ── Content card ── */}
      <div style={{
        flex: 1,
        background: '#fff',
        borderRadius: '0 8px 8px 8px',
        padding: 32,
        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
        minHeight: 800,
      }}>
        <div style={{ display: activeTab === 0 ? 'block' : 'none' }}>
          {isSpSc ? (
            <TraduccionSPSC item={item} documents={documents} loadingDocuments={loadingDocuments} isFromComp6={isFromComp6} onCompleted={onCompleted} />
          ) : (
            <TraduccionSCSP
              item={item}
              documents={documents}
              loadingDocuments={loadingDocuments}
              isFromComp6={isFromComp6}
              onCompleted={onCompleted}
              onSwitchToCompromiso={() => compromisoTabIndex !== -1 && setActiveTab(compromisoTabIndex)}
            />
          )}
        </div>
        {!isFromComp6 && !isSpSc && (
          <div style={{ display: activeTab === 1 ? 'block' : 'none' }}>
            <CompromisoDetalle6 item={item} onSaved={() => { setCompromisoSaved(true); onRefresh?.(); }} />
          </div>
        )}
      </div>

    </div>
  );
};

export default TraductorContent;
